import { connect, MapDispatchToProps, MapStateToProps } from 'react-redux';
import { Props } from './MoreMenuMobileDropdown';
import { showReportModal } from '../../../../Moderation/redux/actions';
import {
  shareDeviationToPost,
  unpublishDeviation,
} from '../../../../redux/deviations/actionCreators';

type StateProps = Pick<Props, never>;
type DispatchProps = Pick<
  Props,
  'showReportModal' | 'shareDeviationToPost' | 'unpublishDeviation'
>;
type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps: MapStateToProps<StateProps, OwnProps, {}> = () => ({});

const mapDispatchToProps: MapDispatchToProps<DispatchProps, OwnProps> = {
  showReportModal,
  shareDeviationToPost,
  unpublishDeviation,
};

export default connect(mapStateToProps, mapDispatchToProps);
